import { extractCookie, setCookie } from 'lib/web/cookieUtils'

const COOKIE_KEY = 'bypass_region'
const TTL_SECONDS = 7 * 24 * 60 * 60 // 7 days

export function getBypassRegionCookie(): boolean {
  return extractCookie(document.cookie, COOKIE_KEY) === 'true'
}

// Only sets the cookie if it isn't already present — preserves original expiry
export function setBypassRegionCookieOnce() {
  if (!getBypassRegionCookie()) {
    setCookie(COOKIE_KEY, 'true', TTL_SECONDS, '/', 'Lax', document.domain)
  }
}
